import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";
import Iframe from "react-iframe";
import LoadingBackdrop from "../../components/LoadingBackdrop";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

function str_pad_left(string, pad, length) {
  return (new Array(length + 1).join(pad) + string).slice(-length);
}

const StyledDialog = styled(Dialog)`
  & > .MuiDialog-container > .MuiDialog-paperWidthSm {
    max-height: 950px;
    max-width: 1335px;
  }
`;

const DeviceFrame = ({
  item,
  handleClose = () => {},
  url,
  date, // ms dell'open
  loading,
}) => {
  const { t } = useTranslation();

  const DURATION_MS = 30 * 60 * 1000; // 30 minuti

  const endTimeRef = useRef(date + DURATION_MS);
  const intervalRef = useRef(null);

  const [remainingMs, setRemainingMs] = useState(() => {
    return Math.max(0, endTimeRef.current - Date.now());
  });

  const tick = () => {
    const ms = Math.max(0, endTimeRef.current - Date.now());
    setRemainingMs(ms);
    if (ms === 0) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }
  };

  useEffect(() => {
    intervalRef.current = setInterval(tick, 250);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const minutes = Math.floor(remainingMs / 60000);
  const seconds = Math.floor((remainingMs % 60000) / 1000);

  return (
    <StyledDialog
      open={true}
      onClose={() => {
        handleClose();
      }}
      scroll="body"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h4">{item.name}</Typography>
          {remainingMs > 0 && (
            <Box paddingLeft={5}>
              <Typography variant="h4">
                {str_pad_left(minutes, "0", 2) +
                  ":" +
                  str_pad_left(seconds, "0", 2)}
              </Typography>
            </Box>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        {loading ? <LoadingBackdrop /> : null}
        {remainingMs > 0 ? (
          <Box
            display="flex"
            justifyContent="center"
            width={1}
            height={1}
            alignItems="center"
          >
            {url ? (
              <Iframe
                url={url}
                width="1320px"
                height="805px"
                display="initial"
                position="relative"
                overflow="scroll"
              />
            ) : null}
          </Box>
        ) : (
          <Box
            display="flex"
            justifyContent="center"
            width={1}
            height={1}
            alignItems="center"
          >
            <Typography variant="h4">{t("device_frame.timeout")}</Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleClose();
          }}
          color="primary"
          disabled={loading}
        >
          Close
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default DeviceFrame;
